module.exports = __webpack_public_path__ + "img/Speaker=CUTC Team.8713e893.png";